import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-remark-popup',
  templateUrl: './remark-popup.component.html',
  styleUrls: ['./remark-popup.component.scss'],
})
export class RemarkPopupComponent implements OnInit {
  remarkForm: FormGroup;
  response;
  Remark;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public _userService: UserManagementService,
    public dialogRef: MatDialogRef<RemarkPopupComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.remarkForm = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  //get f() { return this.marketrateform1.controls; }
  submit() {
    if (this.remarkForm.valid) {
      this.dialogRef.close(this.remarkForm.value.Remark);
    } else {
      alert('Please write a valid reason');
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
